import {
  ANCHOS_PAPEL,
  AYUDA_TRANSPORTE,
  BAUDIOS,
  CODIFICACIONES,
  CONFIGURACION_IMPRESORAS_VACIA,
  CONFIGURACION_IMPRESORA_POR_DEFECTO,
  DENSIDADES,
  LENGUAJES,
  MEDIDAS_ETIQUETA,
  NOMBRE_CODIFICACION,
  NOMBRE_LENGUAJE,
  NOMBRE_PAPEL,
  NOMBRE_TRANSPORTE,
  PAPELES,
  TRANSPORTES,
  conexionCompatible,
  documentosDe,
  esIos,
  guardarConfiguracionImpresora,
  guardarImpresoras,
  hojaDeImpresora,
  idImpresora,
  impresoraDe,
  leerConfiguracionImpresora,
  leerImpresoras,
  migrarConfiguracionImpresora,
  nombreSugerido,
  normalizarImpresora,
  normalizarImpresoras,
  nuevaImpresora,
  opcionesDocumento,
  quitarImpresora,
  transportesDisponibles
} from "./chunk-IX4ED2ZW.js";

// src/aviso.ts
function avisoImpresion(r) {
  if (r.via === "impresora") return { mensaje: "Comprobante impreso", tipo: "ok" };
  if (r.via === "pdf")
    return r.motivo === "sin_impresora" ? { mensaje: "Sin impresora conectada: el comprobante salió en PDF", tipo: "info" } : { mensaje: `La impresora falló: salió en PDF. ${r.error ?? ""}`.trim(), tipo: "error" };
  return { mensaje: `No se pudo imprimir: ${r.error}`, tipo: "error" };
}
export {
  ANCHOS_PAPEL,
  AYUDA_TRANSPORTE,
  BAUDIOS,
  CODIFICACIONES,
  CONFIGURACION_IMPRESORAS_VACIA,
  CONFIGURACION_IMPRESORA_POR_DEFECTO,
  DENSIDADES,
  LENGUAJES,
  MEDIDAS_ETIQUETA,
  NOMBRE_CODIFICACION,
  NOMBRE_LENGUAJE,
  NOMBRE_PAPEL,
  NOMBRE_TRANSPORTE,
  PAPELES,
  TRANSPORTES,
  avisoImpresion,
  conexionCompatible,
  documentosDe,
  esIos,
  guardarConfiguracionImpresora,
  guardarImpresoras,
  hojaDeImpresora,
  idImpresora,
  impresoraDe,
  leerConfiguracionImpresora,
  leerImpresoras,
  migrarConfiguracionImpresora,
  nombreSugerido,
  normalizarImpresora,
  normalizarImpresoras,
  nuevaImpresora,
  opcionesDocumento,
  quitarImpresora,
  transportesDisponibles
};
//# sourceMappingURL=index.js.map